import { render } from "./TxggTabs.vue?vue&type=template&id=7b55a255&scoped=true"
import script from "./TxggTabs.vue?vue&type=script&lang=js"
export * from "./TxggTabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b55a255"]])

export default __exports__